import { MEDIA_QUERIES } from 'javascripts/constants';
import TabBox from 'javascripts/utils/TabBox';
import TimelineSlider from './TimelineSlider';

let componentStore = [];

function onMediaQueryChange(mq) {
  componentStore.forEach(component => component.deconstructor && component.deconstructor());
  componentStore = [];

  document
    .querySelectorAll('.timeline')
    .forEach(($timeline) => {
      componentStore.push(
        new TimelineSlider($timeline, mq),
        new TabBox($timeline),
      );
    });
}

const mql = window.matchMedia(MEDIA_QUERIES.m);

mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
